import { Form } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { format } from 'rut.js';

const usePatientLoginForm = ({ getPatientData, countryCode }) => {
  const [documentType, setDocumentType] = useState(countryCode && countryCode.toUpperCase() === 'CL' ? 'rut' : 'dni');
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldValue('documentType', documentType);
  }, [documentType, form]);

  const onFinishForm = useCallback((values) => {
    form.validateFields().then(() => {
      if (values.documentType === 'rut') {
        values.documentNumber = format(values.documentNumber, { dots: false });
      }
      getPatientData.setParams(values);

    });
  }, [form, getPatientData]);

  return { onFinishForm, form, documentType, setDocumentType };
}

export default usePatientLoginForm;
